import HomeFormsRoute from '@/modules/workflow/forms/homepage/routes'
import CtrlCampos from '@/modules/workflow/forms/ctrl-campos/routes'
import CtrlFormularioDinamico from '@/modules/workflow/forms/ctrl-formularios-dinamicos/routes'

const routes = [
  ...HomeFormsRoute,
  ...CtrlCampos,
  ...CtrlFormularioDinamico
]

export default routes